// @flow

/**
 * Chat Window Component
 * Main chat component using extracted presentational components
 * Generic version for ai-prompt-management
 */

import React from 'react';
import MessageList from './MessageList';
import useScrollOrchestrator from '../hooks/useScrollOrchestrator';
import { usePromptChatState } from '../context';
import { ScrollServiceContext } from '../context/ScrollServiceContext';

const ChatWindow = () => {
  // Read all state from context
  const state = usePromptChatState();
  
  const { messages, isStreaming, autoScrollThreshold } = state;

  const scrollService = useScrollOrchestrator(
    messages, 
    isStreaming,
    {
      threshold: autoScrollThreshold,
    }
  );

  const { containerRef, endRef, handleScroll } = scrollService;

  return (
    <ScrollServiceContext.Provider value={scrollService}>
      <MessageList
        ref={containerRef}
        messages={messages}
        activeStreamMessageId={state.activeStreamMessageId}
        onScroll={handleScroll}
        endRef={endRef}
      />
    </ScrollServiceContext.Provider>
  );
};

export default ChatWindow;
